import { makeStyles, TableCell } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

const StyledTableHeadCell = withStyles(() => ({
   head: {
     border: 'none',
     backgroundColor: '#E5E5E5',
     color: '#101010',
     fontSize: '1rem',
     padding: 6,
   },
 }))(TableCell);

 const StyledTableCell = withStyles(() => ({
  root: (props) => ({
    padding: props.condensed ? 1 : 5, 
  }),
}))(TableCell);

const useStyles = makeStyles(() => ({
  mobileCard: {
    background: 'white',
    borderRadius: '16px',
    padding: 15,
    margin: 10,
    border: '3px white solid',
  },
  flexLine: {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
  },
  flexLineDefault: {
    display: 'flex',
    alignItems: 'center',
  },
  flexLineItem: {
    width: '50%',
    alignItems: 'center',
    whiteSpace: 'no-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  columnTitle: {
    width: '40%',
    fontWeight: '600',
  },
  columnValue: {
    whiteSpace: 'no-wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '60%',
  },
}));

export {
  StyledTableCell,
  StyledTableHeadCell,
  useStyles
}